
import React, { useEffect } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Projects from './components/Projects';
import Stack from './components/Stack';
import Footer from './components/Footer';
import PopupController from './components/PopupController';
import { getCalApi } from "@calcom/embed-react";

const App: React.FC = () => {
  useEffect(() => {
    (async function () {
      const cal = await getCalApi({"namespace":"gtm-audit-revenue-bottleneck-identification"});
      cal("ui", {"theme":"dark","hideEventTypeDetails":false,"layout":"month_view"});
    })();
  }, []);

  return (
    <div className="min-h-screen bg-slate-950 text-slate-100 selection:bg-emerald-500/30">
      {/* Background Decor */}
      <div className="fixed inset-0 pointer-events-none -z-10">
        <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(circle_at_50%_0%,rgba(16,185,129,0.05),transparent_50%)]"></div>
        <div className="absolute bottom-0 right-0 w-full h-full bg-[radial-gradient(circle_at_100%_100%,rgba(16,185,129,0.03),transparent_40%)]"></div>
      </div>

      <Navbar />
      <main>
        <section id="hero">
          <Hero />
        </section>
        <section id="about" className="py-24">
          <About />
        </section>
        <section id="work" className="py-24 bg-slate-900/30">
          <Projects />
        </section>
        <section id="stack" className="py-24">
          <Stack />
        </section>
      </main>
      <Footer />
      
      {/* Conversion Engine Popups */}
      <PopupController />
    </div>
  );
};

export default App;
